import { Phone } from "lucide-react";
import { COMPANY, buildWhatsAppLink } from "../../lib/constants";

export const CTASection = () => {
    return (
        <section
            data-testid="cta-section"
            className="relative bg-[#f45100] py-16 md:py-24 overflow-hidden"
        >
            {/* Diagonal stripes accent */}
            <div className="absolute top-0 left-0 right-0 h-2 emergency-stripes" />
            <div className="absolute bottom-0 left-0 right-0 h-2 emergency-stripes" />

            <div className="container mx-auto px-4 md:px-8 relative z-10 text-center">
                <span className="text-xs font-bold tracking-[0.4em] uppercase text-black/70">
                    · Precisando de guincho urgente? ·
                </span>
                <h2 className="font-display text-4xl sm:text-5xl md:text-7xl font-black uppercase tracking-tight text-white mt-4 leading-[0.95] max-w-5xl mx-auto">
                    Chame a RCM agora.
                    <br />
                    <span className="text-black">Estamos a um toque.</span>
                </h2>
                <p className="mt-6 text-white/95 text-base md:text-xl max-w-2xl mx-auto font-medium">
                    Atendimento rápido 24h em Praia Grande. WhatsApp ou
                    ligação — você decide.
                </p>

                <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center max-w-2xl mx-auto">
                    <a
                        href={buildWhatsAppLink()}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-whatsapp-btn"
                        className="inline-flex items-center justify-center gap-3 px-8 py-5 bg-[#25D366] hover:bg-[#1ebd5c] text-white rounded-2xl font-extrabold text-base md:text-lg shadow-2xl shadow-black/30 transition-all duration-300 hover:scale-[1.02]"
                    >
                        <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                        </svg>
                        Falar agora no WhatsApp
                    </a>
                    <a
                        href={COMPANY.phoneTel}
                        data-testid="cta-phone-btn"
                        className="inline-flex items-center justify-center gap-3 px-8 py-5 bg-black hover:bg-white hover:text-black text-white rounded-2xl font-extrabold text-base md:text-lg shadow-2xl shadow-black/30 transition-all duration-300 hover:scale-[1.02]"
                    >
                        <Phone size={22} strokeWidth={2.5} />
                        {COMPANY.phone}
                    </a>
                </div>
            </div>
        </section>
    );
};
